import { Directive, OnChanges, OnInit, Input, ElementRef, OnDestroy, SimpleChanges } from "@angular/core";
import { Subject} from "rxjs";
import { MathMlService } from "./math-ml.service";
import { take, takeUntil } from "rxjs/operators";

@Directive({
  selector: '[mathMl]'
})
export class MathMlDirective implements OnInit, OnChanges, OnDestroy {
  @Input()
  public mathMl!: any;
  private alive$ = new Subject<boolean>();
  private readonly el: HTMLElement;

  constructor(private MathMlService: MathMlService, private elementRef: ElementRef) {
    this.el = elementRef.nativeElement;
  }

  ngOnInit() {
    this.render();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes && changes['mathMl'] && changes['mathMl'].currentValue) {
      this.render();
    }
  }

  private render() {
    this.MathMlService.ready().pipe(
      take(1),
      takeUntil(this.alive$)
    ).subscribe(() => this.MathMlService.render(this.el, this.mathMl));
  }

  ngOnDestroy() {
    this.alive$.next(false);
  }

}
